import React, { useState } from 'react';
import { EmailMailbox } from '../types';

interface EmailMoveDialogProps {
  mailboxes: EmailMailbox[];
  currentMailbox: string;
  loading: boolean;
  error: string | null;
  onMove: (destination: string) => Promise<void>;
  onCancel: () => void;
}

const EmailMoveDialog: React.FC<EmailMoveDialogProps> = ({
  mailboxes,
  currentMailbox,
  loading,
  error,
  onMove,
  onCancel
}) => {
  const [destination, setDestination] = useState('');
  const [moving, setMoving] = useState(false);
  const [moveError, setMoveError] = useState<string | null>(null);

  const options = mailboxes.filter(m => m.path !== currentMailbox);

  const handleMove = async () => {
    if (!destination) return;
    setMoving(true);
    setMoveError(null);
    try {
      await onMove(destination);
    } catch (err) {
      setMoveError(err instanceof Error ? err.message : 'Failed to move message');
      setMoving(false);
    }
  };

  return (
    <div className="email-move-dialog">
      <div className="email-move-dialog-header">
        <h4>Move to</h4>
        <button type="button" className="email-reply-cancel-btn" onClick={onCancel} disabled={moving}>
          Cancel
        </button>
      </div>

      {loading && options.length === 0 ? (
        <div className="email-reply-composer-loading">Loading folders…</div>
      ) : (
        <>
          <label className="email-reply-field">
            <span className="email-reply-field-label">Folder</span>
            <select
              className="app-form-select"
              value={destination}
              onChange={(e) => setDestination(e.target.value)}
              disabled={moving}
            >
              <option value="">Select folder…</option>
              {options.map(box => (
                <option key={box.path} value={box.path}>{box.name}</option>
              ))}
            </select>
          </label>

          {(moveError || error) && (
            <div className="email-reply-error">{moveError || error}</div>
          )}

          <div className="email-reply-actions">
            <button
              type="button"
              className="app-btn app-btn-primary"
              onClick={handleMove}
              disabled={moving || !destination}
            >
              {moving ? 'Moving…' : 'Move'}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EmailMoveDialog;
